/*
 * A firm user previewing a contact's HR portal. The preview lives in this
 * tab's sessionStorage, so the firm app in other tabs is unaffected; the
 * server answers GETs as the contact and refuses every write.
 */
import { PORTAL_PATH } from "./routes";

const KEY = "companyPortalPreview";
export const PREVIEW_PARAM = "preview";
export const PREVIEW_HEADER = "X-Portal-Preview";

export const portalPreview = (): string | null => sessionStorage.getItem(KEY);

export const startPortalPreview = (value: string): void =>
  sessionStorage.setItem(KEY, value);

export const endPortalPreview = (): void => sessionStorage.removeItem(KEY);

export const portalPreviewUrl = (
  companyId: string,
  contactId: string
): string =>
  `${PORTAL_PATH}?${PREVIEW_PARAM}=${encodeURIComponent(
    `${companyId}:${contactId}`
  )}`;
